import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner"]

  connect() {
    this.timeout = null
    // An input marked data-autosubmit-ignore submits only the browser's own way, e.g. a search field on Enter.
    this.element.querySelectorAll("input:not([data-autosubmit-ignore]), select").forEach(input => {
      input.addEventListener("change", () => this.debouncedSubmit())
    })
  }

  // A pending submit belongs to this form. Cancel it when the form leaves the page, so the
  // timer does not outlive the element it submits.
  disconnect() {
    clearTimeout(this.timeout)
  }

  debouncedSubmit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.submit()
    }, 150)
  }

  submit() {
    // Swap the inputs for the spinner, but only when there is a spinner to swap
    // in. Without that guard a form with no spinner target just empties its own
    // controls for the length of the request and offers nothing in their place
    // — on a slow response that reads as a broken page, and a failed one never
    // puts them back.
    if (this.hasSpinnerTarget) {
      this.element.querySelectorAll("input, select").forEach(input => {
        input.classList.add("hidden")
      })

      this.spinnerTarget.classList.remove("hidden")
    }

    this.element.requestSubmit()
  }
}
